import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Form } from './Form';
// import { Heading } from './Heading';
import Authentication from '../../common/Authentication';
import GiveOverlayModal from './GiveOverlayModal';
import LayoutContext from '../../../contexts/Layout';

export const Giving = props => {
    const { layout } = useContext(LayoutContext);
    const [displayAuth, setDisplayAuth] = useState(false);

    return (
        <View dataSet={{ umbracoComponentName: props.nodeTypeAlias }} style={{ width: props.width }}>
            <LinearGradient colors={['#5C6D7F', '#fff']} locations={[0.5, 0.5]} style={{ height: '100%', width: '100%' }}>
                <View style={{ alignItems: 'center', marginBottom: layout.styleGuide.componentSeparator }}>
                    {/* <Heading setDisplayAuth={setDisplayAuth} signInLinkText='Sign in or Register' /> */}
                    <Form {...props} width={props.width} />
                    {props.asModal && <GiveOverlayModal />}
                    <Authentication {...props} visible={displayAuth} setVisible={setDisplayAuth} />
                </View>
            </LinearGradient>
        </View>
    );
};
